import {
  GET_FOC_REPORT_REQUEST,
  GET_FOC_REPORT_SUCCESS,
  GET_FOC_REPORT_ERROR

} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_FOC_REPORT_REQUEST:
            return {
                loading: true,
            };
        case GET_FOC_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_FOC_REPORT_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}